import React from 'react'
import profileImg from '../../../assets/images/profileImg.svg'
import { hasMembershipType } from '../../utils'
import { isCompleteStatus } from './utils'
import {
  Container,
  ProfileImage,
  ContentWrapper,
  LeftSection,
  ProfileInfo,
  NameRow,
  Name,
  Badge,
  Details,
  SectionName,
  FacilityName,
  MemberId,
  EditLink,
  EditText
} from './Styles/ProfileBrief.styles'

const ProfileBrief = ({ me, levelState, onEditClick, authReady }) => {
  if (!authReady || !me) return null

  const displayName = me.displayName || `${me.firstName} ${me.lastName}`

  const getMemberStatus = () => {
    if (!levelState) {
      return 'Level 2 Associate'
    }

    const qualifyingLevel = levelState.qualifying
    const level1 = levelState.level1
    const level2 = levelState.level2
    const level3 = levelState.level3

    const courseManualsRequirement = qualifyingLevel?.requirements?.find(req => req.id === 'course_manuals')
    const applicationRequirement = qualifyingLevel?.requirements?.find(req => req.id === 'application')

    const isCourseManualsComplete = courseManualsRequirement && isCompleteStatus(courseManualsRequirement.status)
    const isApplicationComplete = applicationRequirement && isCompleteStatus(applicationRequirement.status)

    const isLevel1Complete = level1?.requirements?.every(req => isCompleteStatus(req.status))
    const isLevel2Complete = level2?.requirements?.every(req => isCompleteStatus(req.status))
    const isLevel3Complete = level3?.requirements?.every(req => isCompleteStatus(req.status))

    if (isLevel3Complete) {
      return 'Level 3 Associate'
    } else if (isLevel2Complete) {
      return 'Level 3 Associate' 
    } else if (isLevel1Complete) {
      return 'Level 2 Associate'
    } else if (isApplicationComplete) {
      return 'Level 1 Associate'
    } else if (isCourseManualsComplete) {
      return 'Qualifier Eligible'
    } else {
      return 'Pre-Qualifier'
    }
  }

  const badgeText = getMemberStatus()

  return (
    <Container>
      <ProfileImage 
        src={me.profilePhoto || me.photo || profileImg} 
        square={me.profilePhoto || me.photo}
        alt={displayName}
      />
      <ContentWrapper>
        <LeftSection>
          <ProfileInfo>
            <NameRow>
              <Name>{displayName}</Name>
              <Badge>{badgeText}</Badge>
            </NameRow>
            <Details>
              {me.section && (
                <SectionName>{me.section.name}</SectionName>
              )}
              {me.primaryFacility && (
                <FacilityName>{me.primaryFacility.name}</FacilityName>
              )}
              {hasMembershipType(me) && (
                <MemberId>Member ID: #{me.id}</MemberId>
              )}
            </Details>
          </ProfileInfo>
        </LeftSection>
        {hasMembershipType(me) && (
          <EditLink onClick={onEditClick || (() => window.location.href = '/profile/edit')}>
            <EditText>Edit My Profile</EditText>
            <i className='fa fa-angle-right' style={{ color: '#0082CE' }} />
          </EditLink>
        )}
      </ContentWrapper>
    </Container>
  )
}

export default ProfileBrief
